<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useDevice } from '#imports'
import type { ItemNews } from '~/composables/news/interface'
import { useDelay } from '~/composables/common/use-delay'

const router = useRouter()
const { isMobile } = useDevice()
const props = defineProps({
  item: {
    type: Object as () => ItemNews,
    default: () => {}
  },
  categoryName: {
    type: String,
    default: ''
  },
  categorySlug: {
    type: String,
    default: ''
  },
  hasPadding: {
    type: Boolean,
    default: false
  }
})
const { loading } = useDelay(500)
const hanldeClickCategory = (): void => {
  if (props.categorySlug) {
    router.push(`/${props.categorySlug}`)
  }
}
</script>
<template>
  <article>
    <div :class="['news', { mobile: isMobile }]">
      <div class="news__thumb hover-shine is-vertical">
        <NuxtLink :to="'/' + item.slug" :title="item.title">
          <NuxtImg
            v-if="loading || !item.image"
            format="webp"
            src="/assets/images/mobile/news/news-default.png"
            :alt="item.title"
            densities="1x"
            preload
          />
          <NuxtImg v-else format="webp" :src="item.image" :alt="item.title" densities="1x" preload />
        </NuxtLink>
      </div>
      <div class="news__content" :class="hasPadding ? 'p-12' : ''">
        <div class="news__title">
          <NuxtLink :to="'/' + item.slug" :title="item.title" class="line-limit-2">
            {{ item.title }}
          </NuxtLink>
        </div>
        <div class="news__footer">
          <div v-if="categoryName || item.category" class="news__category-slug" @click="hanldeClickCategory()">
            {{ item.category ?? categoryName }}
          </div>
          <div class="news__ctn-time wrapper-date-time">
            <div class="date-time">
              <div class="date">{{ item.date || item.publishTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/pages/news/news-item.scss';
</style>
